'use client'
import { Inter } from 'next/font/google'
import InitColorSchemeScript from '@mui/material/InitColorSchemeScript'
import { CssBaseline } from '@mui/material'
import { AppRouterCacheProvider } from '@mui/material-nextjs/v13-appRouter'
import { ThemeProvider } from '@mui/material/styles'

import '@/app/globals.css'
import theme from '@/shared/theme/theme'
import ReduxProvider from '@/components/global/layout/ReduxProvider'
import ToastContainerWrapper from '../toast/ToastContainerWrapper'
import WhatsappStatusControl from '../dialogs/WhatsappStatusControl'
import FailedPaymentAlert from './FailedPaymentAlert'
import WhatsappBillingAlert from './WhatsappBillingAlert'
import SystemUpdateRequiredPrompt from '../system-update/SystemUpdateRequiredPrompt'

const inter = Inter({ subsets: ['latin'] })

export default function DefaultLayout({
  children,
  colorBackground,
  isLogged,
}: Readonly<{
  children: React.ReactNode
  isLogged?: boolean
  colorBackground?: boolean
}>) {
  const bodyBackground = colorBackground
    ? 'linear-gradient(to bottom, var(--mui-palette-background-paper) 0%, var(--mui-palette-brand-50) 80%, var(--mui-palette-brand-200) 100%)'
    : 'var(--mui-palette-background-paper)'

  return (
    <html lang="pt" suppressHydrationWarning>
      <body
        className={inter.className}
        style={{
          minHeight: '100dvh',
          width: '100%',
          background: bodyBackground,
        }}
      >
        <InitColorSchemeScript attribute="class" />
        <AppRouterCacheProvider>
          <ThemeProvider
            theme={theme}
            defaultMode="system"
            disableTransitionOnChange
          >
            <ReduxProvider>
              <CssBaseline />
              <FailedPaymentAlert />
              {isLogged && <WhatsappBillingAlert />}
              {isLogged && <WhatsappStatusControl />}
              {children}
              <SystemUpdateRequiredPrompt />
              <ToastContainerWrapper />
            </ReduxProvider>
          </ThemeProvider>
        </AppRouterCacheProvider>
      </body>
    </html>
  )
}
